// import Payment from "../components/Payment";
import Payment from "../components/PaymentMubeenAccount";
const HomePage = () => {
  const handleWhatsAppClick = (packageName = "General Inquiry") => {
    const message = encodeURIComponent(
      `Hi! I'm interested in your database services. ${
        packageName !== "General Inquiry"
          ? `Specifically the ${packageName} package.`
          : ""
      } Could you please provide more details?`,
    );
    const phoneNumber = "+923001234567"; // Replace with actual WhatsApp number
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };
 
  const featuredPackages = [
    {
      id: 1,
      name: "Standard",
      price: 3850,
      originalPrice: 4500,
      currency: "PKR",
      features: ["4GB Storage", "50GB Backup Space", "100 Concurrent Connections"],
      color: "primary",
      isPopular: false,
      paymentType: "monthly",
    },
    {
      id: 2,
      name: "Popular",
      price: 5850,
      originalPrice: 7500,
      currency: "PKR",
      features: ["8GB Storage", "100GB Backup Space", "500 Concurrent Connections"],
      color: "success",
      isPopular: true,
      paymentType: "monthly",
    },
    {
      id: 3,
      name: "Pro",
      price: 11500,
      originalPrice: 14500,
      currency: "PKR",
      features: ["16GB Storage", "250GB Backup Space", "1000 Concurrent Connections"],
      color: "warning",
      isPopular: false,
      paymentType: "monthly",
    },
    {
      id: 4,
      name: "Enterprise Database",
      price: 80000,
      originalPrice: 95000,
      currency: "PKR",
      features: [
        "32GB Storage",
        "500GB Backup Space",
        "Unlimited Connections",
        "Free Setup & Migration",
        "Priority Support",
      ],
      color: "success",
      isPopular: false,
      paymentType: "onetime",
    },
  ];
 
  const stats = [
    { number: "99.99%", label: "Uptime Guarantee" },
    { number: "24/7", label: "Support Available" },
    { number: "1000+", label: "Happy Clients" },
    { number: "5+", label: "Years Experience" },
  ];
 
  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      {/* Hero Section */}
      <section
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          padding: "100px 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="30" cy="30" r="4"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
            opacity: 0.3,
          }}
        ></div>
 
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1
                style={{
                  fontSize: "3.5rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                  lineHeight: "1.2",
                }}
              >
                Premium DataBase Solutions{" "}
              </h1>
              <p
                style={{
                  fontSize: "1.3rem",
                  opacity: 0.9,
                  marginBottom: "30px",
                  lineHeight: "1.6",
                }}
              >
                Experience lightning-fast performance with our high-quality
                database solutions. Built for businesses that demand reliability
                and speed with MySQL, PostgreSQL, MongoDB and more.
              </p>
              <div className="d-flex flex-column flex-sm-row gap-3">
                <button
                  className="btn btn-light btn-lg"
                  onClick={() => handleWhatsAppClick()}
                  style={{
                    fontWeight: "bold",
                    padding: "15px 30px",
                    fontSize: "1.1rem",
                    color: "#667eea",
                    border: "none",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                  }}
                >
                  💬 Get Started Now
                </button>
                <a
                  href="/database-services"
                  className="btn btn-outline-light btn-lg"
                  style={{
                    fontWeight: "bold",
                    padding: "15px 30px",
                    fontSize: "1.1rem",
                    borderWidth: "2px",
                  }}
                >
                  View All Plans
                </a>
              </div>
            </div>
            <div className="col-lg-6 text-center">
              <div
                style={{
                  background: "rgba(255,255,255,0.1)",
                  borderRadius: "20px",
                  padding: "40px",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                <div style={{ fontSize: "4rem", marginBottom: "20px" }}>🗄️</div>
                <h3 style={{ marginBottom: "15px" }}>DataBase Pro</h3>
                <p style={{ opacity: 0.9 }}>
                  Trusted by 1000+ businesses worldwide for reliable database
                  solutions
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      {/* Stats Section */}
      <section style={{ backgroundColor: "#f8f9fa", padding: "60px 0" }}>
        <div className="container">
          <div className="row">
            {stats.map((stat, index) => (
              <div key={index} className="col-md-3 col-sm-6 text-center mb-4">
                <div
                  style={{
                    background: "white",
                    padding: "30px 20px",
                    borderRadius: "10px",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "translateY(-5px)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <h2
                    style={{
                      fontSize: "2.5rem",
                      fontWeight: "bold",
                      color: "#667eea",
                      marginBottom: "10px",
                    }}
                  >
                    {stat.number}
                  </h2>
                  <p
                    style={{
                      color: "#6c757d",
                      fontSize: "1.1rem",
                      marginBottom: 0,
                    }}
                  >
                    {stat.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
 
      {/* Featured Packages */}
      <section style={{ padding: "80px 0", backgroundColor: "white" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  marginBottom: "20px",
                }}
              >
                Choose Your Perfect Database Plan
              </h2>
              <p
                style={{
                  fontSize: "1.1rem",
                  color: "#6c757d",
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                Start with our most popular database packages designed for every
                business size
              </p>
            </div>
          </div>
 
          <div className="row">
            {featuredPackages.map((pkg, index) => (
              <div key={index} className="col-lg-3 col-md-6 mb-4">
                <div
                  className={`card h-100 ${
                    pkg.isPopular ? "border-success" : ""
                  }`}
                  style={{
                    boxShadow: pkg.isPopular
                      ? "0 10px 30px rgba(40,167,69,0.3)"
                      : "0 5px 15px rgba(0,0,0,0.1)",
                    border: pkg.isPopular
                      ? "2px solid #28a745"
                      : "1px solid #dee2e6",
                    transform: pkg.isPopular ? "scale(1.05)" : "scale(1)",
                    transition: "all 0.3s ease",
                    position: "relative",
                  }}
                >
                  {pkg.isPopular && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-10px",
                        right: "20px",
                        background: "#28a745",
                        color: "white",
                        padding: "5px 15px",
                        borderRadius: "20px",
                        fontSize: "0.8rem",
                        fontWeight: "bold",
                      }}
                    >
                      MOST POPULAR
                    </div>
                  )}
 
                  <div className="card-body text-center">
                    <h3
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        color: "#2c3e50",
                        marginBottom: "20px",
                      }}
                    >
                      {pkg.name}
                    </h3>
 
                    <div style={{ marginBottom: "20px" }}>
                      <span
                        style={{
                          fontSize: "0.9rem",
                          color: "#6c757d",
                          textDecoration: "line-through",
                        }}
                      >
                        {pkg.originalPrice}
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: "2.5rem",
                          fontWeight: "bold",
                          color: "#e74c3c",
                        }}
                      >
                        {pkg.price}
                      </span>
                      <span style={{ fontSize: "1rem", color: "#6c757d" }}>
                        {pkg.paymentType === "monthly" ? "/month" : " (One-time)"}
                      </span>
                    </div>
 
                    <ul className="list-unstyled mb-4">
                      {pkg.features.map((feature, idx) => (
                        <li
                          key={idx}
                          style={{
                            padding: "5px 0",
                            color: "#495057",
                          }}
                        >
                          <span
                            style={{ color: "#28a745", marginRight: "8px" }}
                          >
                            ✓
                          </span>
                          {feature}
                        </li>
                      ))}
                    </ul>
 
                    <button
                      className={`btn btn-${pkg.color} btn-lg w-100`}
                      onClick={() => handleWhatsAppClick(pkg.name)}
                      style={{
                        fontWeight: "bold",
                        padding: "12px",
                        fontSize: "1rem",
                      }}
                    >
                      Get Started
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Payment/>

      {/* Why Choose Us Section */}
      <section
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          padding: "80px 0",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Why Choose DataBase Pro?
              </h2>
              <p
                style={{
                  fontSize: "1.1rem",
                  opacity: 0.9,
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                We provide enterprise-grade database solutions with unmatched
                performance and support
              </p>
            </div>
          </div>
 
          <div className="row">
            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "rgba(52, 152, 219, 0.2)",
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  fontSize: "3rem",
                }}
              >
                ⚡
              </div>
              <h4 style={{ marginBottom: "15px" }}>Lightning Fast Queries</h4>
              <p style={{ opacity: 0.9 }}>
                Optimized database configurations and SSD storage deliver blazing-fast
                query performance for your applications.
              </p>
            </div>
 
            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "rgba(46, 204, 113, 0.2)",
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  fontSize: "3rem",
                }}
              >
                🛡️
              </div>
              <h4 style={{ marginBottom: "15px" }}>Secure & Protected</h4>
              <p style={{ opacity: 0.9 }}>
                Advanced encryption and automated backups keep your data
                safe and secure 24/7.
              </p>
            </div>
 
            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "rgba(243, 156, 18, 0.2)",
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  fontSize: "3rem",
                }}
              >
                🎧
              </div>
              <h4 style={{ marginBottom: "15px" }}>Expert Support</h4>
              <p style={{ opacity: 0.9 }}>
                Our dedicated database experts are available 24/7 to help you with
                any technical challenges.
              </p>
            </div>
          </div>
        </div>
      </section>
 
      {/* CTA Section */}
      <section
        style={{
          background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
          color: "white",
          padding: "80px 0",
          textAlign: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Ready to Get Started?
              </h2>
              <p
                style={{
                  fontSize: "1.2rem",
                  opacity: 0.9,
                  marginBottom: "30px",
                  maxWidth: "600px",
                  margin: "0 auto 30px",
                }}
              >
                Join thousands of satisfied customers who trust DataBase Pro
                for their database needs. Contact us today for a personalized
                solution!
              </p>
 
              <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                <button
                  className="btn btn-light btn-lg"
                  onClick={() => handleWhatsAppClick()}
                  style={{
                    fontWeight: "bold",
                    padding: "15px 30px",
                    fontSize: "1.1rem",
                    color: "#f5576c",
                    border: "none",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                  }}
                >
                  💬 Chat with Us on WhatsApp
                </button>
                <a
                  href="tel:+923124998010"
                  className="btn btn-outline-light btn-lg"
                  style={{
                    fontWeight: "bold",
                    padding: "15px 30px",
                    fontSize: "1.1rem",
                    borderWidth: "2px",
                  }}
                >
                  📞 Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      {/* Bootstrap CSS */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
};
 
export default HomePage;